interface IConfig {
  [propName: string]: any;
}

class BaseConfig {
  _configInfo: IConfig;
  _commonConfig: IConfig;
  _goartCommonConfig: IConfig;
  private static instance: BaseConfig;
  constructor() {
    this._commonConfig = require("./commonConfig.json");
    this._goartCommonConfig = require("./goartCommonConfig.json");
    this._configInfo = {
      "development":require("./devConfig.json"),
      "production":require("./prodConfig.json"),
      "local":require("./localConfig.json"),
    }[process.env.APP_ENV!]

    console.log('=======>baseUrl',process.env.APP_ENV)
  }

  static getInstance() {

    if (!this.instance) {
      this.instance = new BaseConfig();
    }
    return this.instance;
  }

  configVal(): IConfig {
    return { ...this._commonConfig, ...this._configInfo, ...this._goartCommonConfig };
  }
}

export default BaseConfig.getInstance().configVal();
